import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';

import { reducers as quoteReducers } from '@sp/client/modules/quote';
import { reducers as planReducers } from '@sp/client/modules/plan';

import plans from './containers/ProviderPlans/reducer';
import user from './containers/Login/reducer';

import providerNewPlanReducers from './containers/ProviderNewPlan/reducers';

import adminReducers from './modules/admin/reducers';

export default combineReducers({
  router: routerReducer,
  form: formReducer,
  user,
  plans,
  admin: adminReducers,
  quote: quoteReducers,
  plan: planReducers,
  ...providerNewPlanReducers,
});
